import React, {memo, useEffect, useRef, useState} from 'react';
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";
import useAuth from "../../../hooks/useAuth";

const EmployeeData = function EmployeeData(props) {
    const {auth} = useAuth();
    // const [users, setUsers] = useState([]);
    // const axiosPrivate = useAxiosIntercept();
    // const ref = useRef(true);
    const [editDeletePop, setEditDeletePop] = useState('');
    // const getUsers = async () => {
    //     let URL = process.env.REACT_APP_USER_INFO_URL + '&user_type='+ "P";
    //     try {
    //         const response = await axiosPrivate.get(URL);
    //         setUsers(response?.data?.response?.data?.user_info);
    //         // setTotalRecords(response?.data?.response?.data?.total_records);
    //     } catch (err) {
    //         console.log(err);
    //     }
    // };
    // useEffect(()=>{
    //     if(ref.current){
    //         ref.current = false;
    //         getUsers();
    //     }
    // },[])

    const userEdit = (data) => {
        props.editEmployee(data);
    }
    const handleClick = (data) =>{
        if(editDeletePop == data.user_id){
            setEditDeletePop('');
        }
        else{
            setEditDeletePop(data.user_id);
        }
    }

    return (
        <div className="dataTableDynamic">
            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                <tbody>
                <tr>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Role</th>
                    {(auth.userIsRoot == 'Y' || auth.userIsRoot == 'y') && <th>&nbsp;</th>}
                </tr>
                {props.users && props.users.length != 0 ? (props.users.map((data)=>{
                    return(<tr key={data.user_id}>
                            <td>{data.firstname} {data.lastname}</td>
                            {data.designation ? (<td>{data.designation}</td>) : (<td>none</td>) }
                            {data.email ? <td>{data.email}</td> : <td>NA</td>}
                            <td>{data.phone}</td>
                            {data.is_root == "Y" ?
                                (<td>Super Admin</td>)
                                :
                                (<td>Admin</td>)
                            }
                        {(auth.userIsRoot == 'Y' || auth.userIsRoot == 'y') && <td>
                                <div className="actionNav" onClick={(e)=>{handleClick(data)}}>
                                    <i className="material-symbols-rounded mt-m grey" >more_vert</i>
                                    <div className="dropMenuWrap">
                                    { editDeletePop == data.user_id &&
                                        <ul className="dropMenu" style={{ width: 180 }}>
                                            {/* <li> <a href="javascript:void(0);">Active
                                        <label class="toggleSwitch">
                                          <input type="checkbox" checked="">
                                          <span class="slider round"></span> </label>
                                        </a> </li> */}
                                            <li onClick={(e)=>{e.preventDefault(); userEdit(data)}}>
                                                {" "}
                                                <a href="">Edit</a>{" "}
                                            </li>
                                            {data.user_id != auth.userId && <li  onClick={(e)=>{e.preventDefault(); props.delete(data)}}>
                                                {" "}
                                                <a style={{color:"red"}} href="">Delete</a>{" "}
                                            </li>}
                                        </ul>

                                    }
                                    </div>
                                </div>
                            </td>}
                        </tr>)
                    })) :
                    (<div>
                        <p>No Users to Display</p>
                    </div>)

                }
                </tbody>
            </table>

        </div>
    );
}

export default EmployeeData;